/* eslint-disable getter-return */
/**
 * トップページにアニメーション
 */
/* function isPassiveSupported() {
  var passiveSupported = false;

  try {
    window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: function() { passiveSupported = true; } }));
  } catch(err) {
    // console.log(err)
  }

  return passiveSupported;
} */

/* function scrollAddAnimation() {
  if(!document.body.classList.contains('use-animation')) return;
  var scrollY = window.pageYOffset;
  var windowBottom = scrollY + window.innerHeight;
  var timeoutId;

  var targetElem = document.getElementsByClassName('is-animation');
  if(!targetElem) return;

  addClassTarget();

  window.addEventListener('scroll', addClassTarget, isPassiveSupported() ? { passive: true } : false);

  function addClassTarget() {
    if ( timeoutId ) return ;

    timeoutId = setTimeout( function () {

      timeoutId = 0 ;
      targetElem = document.getElementsByClassName('is-animation');

      scrollY = window.pageYOffset;
      windowBottom = scrollY + window.innerHeight;

      for(var i = 0; i<targetElem.length;i++) {
        var elemClientRect = targetElem[i].getBoundingClientRect();
        var targetY = elemClientRect.top + window.pageYOffset;
        if(targetY<windowBottom-100) {
          targetElem[i].classList.add('show-animation');
        }
      }
      var showElem = document.getElementsByClassName('show-animation');
      if(showElem.length === targetElem.length) {
        window.removeEventListener('scroll',addClassTarget);
      }
    }, 100 ) ;
    
  }
}
scrollAddAnimation(); */

const addClass = (e) => {
  e.classList.add('is-show');
}

const elemInViewport = () => {
  const elems = document.querySelectorAll('.has-animation');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        addClass(entry.target);
      }
    });
  }, {});

  elems.forEach(elem => {
    observer.observe(elem);
  });
}
elemInViewport();